import { Check, Clock } from "@gravity-ui/icons";
import { Flex, Icon, Text, Tooltip, User } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect, useMemo } from "react";
import { AUTH_TELEGRAM_BOT_LOGIN } from "src/constants/constants";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { getMeRequest } from "src/store/fetchers";
import { formatDate } from "src/util";
import { TelegramAuth } from "src/widgets";

import { ProfileCard } from "../../components";
import { useUserDataTranslate } from "./hooks";
import {
  getMeTelegramRequest,
  signUpTelegramRequest,
  logoutTelegramRequest,
} from "./store/fetchers";
import { checkTelegramData } from "./util/checkTelegramData";

export const UserDataWidget = () => {
  const [userInfo] = useAtom(getMeRequest.dataAtom);
  const [telegramInfo] = useAtom(getMeTelegramRequest.dataAtom);
  const getMeTelegram = useAction(getMeTelegramRequest);
  const signUpTelegram = useAction(signUpTelegramRequest);
  const logoutTelegram = useAction(logoutTelegramRequest);

  const { isMobile } = useGravityDevice();

  const translates = useUserDataTranslate();

  const fullName = useMemo(() => {
    if (!userInfo) return translates.fullNameNull;

    const fullNameArray = [
      userInfo.lastName,
      userInfo.firstName,
      userInfo.middleName,
    ];
    return fullNameArray.join(" ");
  }, [userInfo, translates]);

  useEffect(() => {
    getMeTelegram();
  }, [getMeTelegram]);

  if (!userInfo) return null;

  return (
    <ProfileCard title={translates.title}>
      <Flex direction={"column"} gap={4} style={{ padding: 6 }}>
        <Flex gap={2} justifyContent={"space-between"} alignItems={"center"}>
          <User
            avatar={{
              text: userInfo.name,
              theme: "brand",
            }}
            name={
              <Text variant={isMobile ? "subheader-2" : "subheader-3"}>
                {userInfo.name}
              </Text>
            }
            description={
              <Tooltip
                placement={"right"}
                style={{
                  backgroundColor: "var(--g-color-base-float)",
                }}
                content={
                  userInfo.isVerified
                    ? translates.email.confirm
                    : translates.email.unconfirm
                }
              >
                <Flex alignItems={"center"} gap={1}>
                  {userInfo.email}
                  <Text color={userInfo.isVerified ? "secondary" : "danger"}>
                    <Icon
                      data={userInfo.isVerified ? Check : Clock}
                      size={18}
                    />
                  </Text>
                </Flex>
              </Tooltip>
            }
            size={isMobile ? "m" : "xl"}
          />
        </Flex>
        <div
          style={{
            height: 1,
            width: "100%",
            backgroundColor: "var(--g-color-base-generic)",
          }}
        />
        <Flex
          wrap={"wrap"}
          gap={4}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Flex direction={"column"} grow={1} gap={1}>
            <Text color="secondary">{translates.userFields.name}</Text>
            <Text>{userInfo.name}</Text>
          </Flex>
          <Flex direction={"column"} grow={1} gap={1}>
            <Text color="secondary">{translates.userFields.email}</Text>
            <Text>{userInfo.email}</Text>
          </Flex>
          <Flex direction={"column"} grow={2.8} gap={1}>
            <Text color="secondary">{translates.userFields.fullName}</Text>
            <Text>{fullName}</Text>
          </Flex>
          <Flex direction={"column"} grow={2.8} gap={1}>
            <Text color="secondary">{translates.userFields.phone}</Text>
            <Text>{userInfo.phone}</Text>
          </Flex>
          <Flex direction={"column"} grow={2.8} gap={1}>
            <Text color="secondary">{translates.userFields.role}</Text>
            <Text>{userInfo.role}</Text>
          </Flex>
          <Flex direction={"column"} grow={1} gap={1}>
            <Text color="secondary">{translates.userFields.accountCreate}</Text>
            <Text>{formatDate(new Date(userInfo.createdAt))}</Text>
          </Flex>
        </Flex>
        <Flex direction={"column"} gap={2}>
          <Text color="secondary">{translates.userFields.social}</Text>
          <TelegramAuth
            botUsername={AUTH_TELEGRAM_BOT_LOGIN}
            userImage={false}
            user={telegramInfo}
            requestAccess={true}
            onTelegramAuth={(user) => signUpTelegram(checkTelegramData(user))}
            onLogout={logoutTelegram}
          />
        </Flex>
      </Flex>
    </ProfileCard>
  );
};
